import { TextField } from '@flex-design-system/fx';
import {
  AwardIcon,
  ChevronDownMiniIcon,
} from '@flex-design-system/legacy-flex-icons';
import { Translation, useTranslation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';
import { VeteranWhether } from '@flex-private-packages/recruiting-common/base';
import { VeteranSelect } from '@flex-private-packages/recruiting-common/components';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import type { JobDescriptionFormState } from '../models';

export function VeteranField({ required }: { required: boolean }) {
  const { control, clearErrors } = useFormContext<JobDescriptionFormState>();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Controller
      key="hasVeteransCompensation"
      control={control}
      name="hasVeteransCompensation"
      rules={{
        required: required
          ? t(trans('recruiting.veteran.edit.helper.required'))
          : false,
      }}
      render={({
        field: { ref, onChange, value },
        fieldState: { invalid, error },
      }) => {
        const label =
          value === VeteranWhether.Included
            ? t(trans('recruiting.veteran.included'))
            : value === VeteranWhether.NotIncluded
              ? t(trans('recruiting.veteran.not_included'))
              : '';
        return (
          <VeteranSelect
            open={isOpen}
            onOpenChange={setIsOpen}
            value={value as VeteranWhether}
            onVeteranChange={newValue => {
              onChange(newValue);
              clearErrors('hasVeteransCompensation');
            }}
          >
            {/** onFocus재호출 방지 */}
            <div role="button">
              <TextField
                key={label}
                defaultValue={label}
                ref={ref}
                variant="solid"
                id="hasVeteransCompensation"
                enterKeyHint="next"
                required={required}
                css={{ cursor: 'pointer' }}
                onFocus={() => {
                  setIsOpen(true);
                }}
                rightSlot={<ChevronDownMiniIcon style={{ marginRight: 12 }} />}
                label={
                  <TextField.Label leftSlot={<AwardIcon />}>
                    <Translation tKey={trans('recruiting.veteran')} />
                  </TextField.Label>
                }
                placeholder={t(trans('recruiting.veteran.edit.placeholder'))}
                state={invalid ? 'error' : 'default'}
                helperText={
                  <TextField.HelperText>{error?.message}</TextField.HelperText>
                }
              />
            </div>
          </VeteranSelect>
        );
      }}
    />
  );
}
